import { render, staticRenderFns } from "./copyAccount.vue?vue&type=template&id=2ae481c9&scoped=true&"
import script from "./copyAccount.vue?vue&type=script&lang=js&"
export * from "./copyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae481c9",
  null
  
)

export default component.exports